import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { VeilcasterWeaponStealFlyOverlay } from './VeilcasterWeaponStealFlyOverlay';

/**
 * Flies stolen weapons from target to Veilcaster one after another.
 */
export const VeilcasterWeaponStealFlyBatchOverlay = ({
  grant,
  weapons,
  cardScale = 1,
  mobileOuterScale = 1,
  isMobileHand = false,
  gameState = null,
  userId = null,
  onComplete,
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const onCompleteRef = useRef(onComplete);
  const batchFinishedRef = useRef(false);

  useLayoutEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const batchGrants = grant?.batchGrants;
  const currentGrant = batchGrants?.[stepIndex];
  const currentWeapon = weapons?.[stepIndex];

  const handleStepComplete = useCallback(() => {
    if (!batchGrants?.length) {
      return;
    }
    setStepIndex((prev) => {
      if (prev + 1 >= batchGrants.length) {
        if (!batchFinishedRef.current) {
          batchFinishedRef.current = true;
          onCompleteRef.current?.();
        }
        return prev;
      }
      return prev + 1;
    });
  }, [batchGrants]);

  if (!grant || !batchGrants?.length || !currentGrant || !currentWeapon) {
    return null;
  }

  return (
    <VeilcasterWeaponStealFlyOverlay
      key={`${grant.key}-step-${stepIndex}-${currentGrant.weaponInstanceId}`}
      grant={currentGrant}
      weapon={currentWeapon}
      cardScale={cardScale}
      mobileOuterScale={mobileOuterScale}
      isMobileHand={isMobileHand}
      gameState={gameState}
      userId={userId}
      onComplete={handleStepComplete}
    />
  );
};

export default VeilcasterWeaponStealFlyBatchOverlay;
